__turbopack_context__.v({
  "block": "Sidebar-module__vjMKHa__block",
  "chevron": "Sidebar-module__vjMKHa__chevron",
  "chevronBtn": "Sidebar-module__vjMKHa__chevronBtn",
  "glass": "Sidebar-module__vjMKHa__glass",
  "kbd": "Sidebar-module__vjMKHa__kbd",
  "leaf": "Sidebar-module__vjMKHa__leaf",
  "leaves": "Sidebar-module__vjMKHa__leaves",
  "nav": "Sidebar-module__vjMKHa__nav",
  "row": "Sidebar-module__vjMKHa__row",
  "rowLink": "Sidebar-module__vjMKHa__rowLink",
  "scroll": "Sidebar-module__vjMKHa__scroll",
  "search": "Sidebar-module__vjMKHa__search",
  "searchText": "Sidebar-module__vjMKHa__searchText",
  "sectionHead": "Sidebar-module__vjMKHa__sectionHead",
  "sectionIcon": "Sidebar-module__vjMKHa__sectionIcon",
  "tree": "Sidebar-module__vjMKHa__tree",
});
